module.exports = __webpack_public_path__ + "static/media/personal-values-large@3x.995fb505.png";